import React from 'react'
import xtend from 'xtend'


import { MdSave } from 'react-icons/lib/md'
import { Modal } from 'react-bootstrap'

class EditStreamTarget extends React.Component {
    constructor (props) {
        super(props)

        this.state = xtend(props, {
            validators: []
        })

        this.serverUrlRef = React.createRef()
        this.streamKeyRef = React.createRef()
        this.destNameRef = React.createRef()
        this.userRef = React.createRef()
        this.passwordRef = React.createRef()

        this.renderInputs = this.renderInputs.bind(this)
        this.submit = this.submit.bind(this)
    }

    submit (ev) {
        ev && ev.preventDefault()

        let { altProviderName } = this.state

        let {
            serverUrlRef,
            streamKeyRef,
            userRef,
            passwordRef,
            destNameRef
        } = this
        let invalid = []

        let serverUrl = serverUrlRef.current.value,
            streamKey = streamKeyRef.current.value,
            destName = destNameRef.current.value,
            userName, password

        if (!serverUrl) invalid.push('serverUrl')
        if (!streamKey) invalid.push('streamKey')

        if (altProviderName == 'Wowza') {

            userName = userRef.current.value
            password = passwordRef.current.value

            if (!userName) invalid.push('userName')
            if (!password) invalid.push('password')
        }

        if (invalid.length) {
            this.setState({ validators: invalid })
        } else {
            let payload = {
                provider: altProviderName,
                altProviderName: altProviderName,
                serverUrl: serverUrl,
                key: streamKey,
                destName: destName,
                altEventStreamID: this.state.altEventStreamID
            }

            if (altProviderName == 'Wowza') {
                payload = xtend(payload, {
                    userName: userName,
                    password: password
                })
            }

            // "null" because function expects a Synthetic Event
            this.props.submit(null, payload)
        }
    }

    render () {

        console.log(this.state);


        let inputs = [
            {
                name: 'destName',
                label: 'Label',
                ref: this.destNameRef,
                optional: true,
                placeholderText: "Friendly name (optional)"
            },{
                name: 'serverUrl',
                label: 'Server URL',
                ref: this.serverUrlRef,
                optional: false,
                placeholderText: "Provider Server URL (required)"
            }, {
                name: 'streamKey',
                label: 'Stream Key',
                ref: this.streamKeyRef,
                optional: false,
                placeholderText: "Provider Stream Key/name (required)"
            }
        ]

        if (this.state.altProviderName == 'Wowza') {
            Array.prototype.push.apply(inputs, [{
                name: 'userName',
                label: 'User Name',
                ref: this.userRef
            }, {
                name: 'password',
                label: 'Password',
                ref: this.passwordRef
            }])
        }

        return <Modal bsSize="large"
            animation={false}
            show={!!this.props.editMode === true}
            onHide={this.props.toggleTargetEdit}>

            <Modal.Header closeButton>
                <h4>Edit Stream Target: {this.state.altProviderName.replace(/-/g, ' ')}</h4>
            </Modal.Header>

            <Modal.Body>
                {inputs.map((input, index) =>
                    this.renderInputs(input, index)
                )}
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-link" onClick={() => {
                    this.props.cancel()
                }}>
                        Cancel
                </button>
                <button className="btn btn-success" onClick={this.submit}>
                    <MdSave/> Save
                </button>
            </Modal.Footer>

        </Modal>
    }

    renderInputs (target, index) {
        let { validators } = this.state

        return <div key={'input-' + index} className={[
            'input-group',
            (validators.indexOf(target.name) > -1) ?
                'has-error' : ''
        ].join(' ')}
        style={{ marginBottom: '1rem' }}>
            <span className="input-group-addon">
                <strong>{target.label}</strong>
            </span>
            <input
                ref={target.ref}
                type="text"
                className="form-control"
                placeholder={target.placeholderText}
                defaultValue={this.state[target.name]}/>
        </div>
    }
}

export default EditStreamTarget